module.exports = __webpack_public_path__ + "img/3-small.bd958227.png";